const book = {
  originPathTips: "Original trajectory",
  sharpturn: "Sharp turn",
  emergencyBrake: "Emergency brake",
  rapidAcceleration: "Rapid acceleration",
  sharpturnCount: "Number of sharp turns",
  emergencyBrakeCount: "Number of sharp deceleration",
  rapidAccelerationCount: "Number of rapid acceleration",
  overSpeedCount: "Number of over speed",
  tripMaxSpeed: "Maximum speed(km/h)",
  tripAvgSpeed: "Average speed(km/h)",
  emergencyBrakeWidth: "200px",
  rapidAccelerationWidth: "200px",
  sharpturnWidth: "200px",
  oil: "Fuel consumption(L)",
  oilNodw: "Fuel consumption",
  oilCost: "Fuel costs(Baht)",
  carbon: "Carbon(kg)",
  tip: "Cancel the trip",
  public: "Public",
  selfDriving: "Self driving",
  view: "View itinerary details",
  endAddress: "End location",
  adminCancelRes: "Administrator cancellation reason",
  orderNumber: "Order NO",
  startOfJourney: "Start of trip",
  endOfTrip: "End of trip",
  appointmentStatus: "Order status",
  travelTime: "Time",
  startingPlace: "Starting location",
  itineraryInformation: "Itinerary information",
  vehicleInformation: "Vehicle information",
  vehicleUseApproval: "Driving behavior",
  vehicleUseApprovalScore: "Driving behaviour score",
  historicalTrack: "Historical track",
  searchLabelWidth: {
    width1: "90px",
    width2: "80px",
    width3: "140px",
    width4: "120px"
  },
  searchWidth: "100px",
  vehiclePersonnel: "Trip user",
  driver: "Driver",
  brand: "Brand",
  orderTime: "Order time",
  cancelNotes: "Cancel reason",
  model: "Model",
  series: "Series",
  mileage: "Mileage",
  drivingBehaviorScore: "Score",
  aperationMileage: "Mileage(km)",
  aperationTiemLenthen: "Time(min)",
  useAdmin: "V2X user",
  labelWidth: {
    orderNumber: "180px",
    orderTime: "180px",
    licensePlate: "200px",
    startOfJourney: "260px",
    endOfTrip: "180px",
    appointmentStatus: "180px",
    vehiclePersonnel: "170px",
    brand: "100px",
    startTime: "150px",
    endTime: "150px",
    note: "100px"
  },
  leftWidth: "130px",
  rightWidth: "140px",
  pass: "Pass",
  notpass: "Not pass",
  error: "Please enter review comments",
  toBeAudited: "Pending",
  toBeReported: "Waiting to go",
  auditFailed: "Rejected",
  cancelReservation: "Cancel",
  adminCancel: "Master cancel",
  completed: "Completed",
  toBeReportedbyReturn: "Waiting to return",
  auditPass: "Passed",
  processing: "Processing",
  cancel: "Cancel reservation",
  error2: "Please enter comments",
  success: "Cancellation of success",
  labelWidth1: "140px",
  historyTrack: {
    playbackSpeed: "Speed of play",
    playbackTrack: "Playback of thack",
    enter: "Enter",
    exit: "Exit",
    progress: "Progress of play",
    error: {
      msg1: "Please search the data after exit the play",
      msg2: "Please select start time and end time",
      msg3: "Start time cannot be later than end time， please reselect it",
      msg4: "You can only search data within 7 days",
      msg5: "No historical track data"
    },
    noData: "No data"
  }
} 
export default book